import { render, staticRenderFns } from "./alertName.vue?vue&type=template&id=1bc99466&scoped=true"
import script from "./alertName.vue?vue&type=script&lang=js"
export * from "./alertName.vue?vue&type=script&lang=js"
import style0 from "./alertName.vue?vue&type=style&index=0&id=1bc99466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc99466",
  null
  
)

export default component.exports